import React, { useState, useEffect } from 'react';
import { withFormik } from 'formik';
import Service from '../../../../../apiService';
import View from './View';
import useDataFetching from '../../../../hooks/useDataFetching';
import Alert from 'view/component/Alert';

const FormPenilaianJasaBoga = ({
  values,
  data,
  setFieldValue,
  handleSubmit,
  backHome,
}) => {
  const { error, loading, results } = useDataFetching({
    url: '/department/penilaian/find/2',
    method: 'get',
  });

  const { results: penilaianResult } = useDataFetching({
    url: `/department/penilaian/result/${data.id}`,
    method: 'get',
  });

  const row = rowMapper(results.data || []);

  const handleChange = (e) =>
    setFieldValue(e.target.name, {
      id: parseInt(e.target.name),
      value: parseInt(e.target.value),
    });

  return (
    <View
      row={ row }
      values={ values }
      penilaianResult={penilaianResult}
      handleChange={ handleChange }
      handleSubmit={ handleSubmit }
    />
  );
};

export default withFormik({
  mapPropsToValues: (props) => ({}),
  handleSubmit: async (fieldValues, { props }) => {
    const results = Object.values(fieldValues).map((value) => value);
    const finalValue = {
      registration_id: props.data.id,
      examiner_id: 1,
      results: results,
    };
    const post = await Service.post('/department/penilaian/upload', finalValue);
    if (post.code === 200) Alert('success', 'Penilaian Berhasil');
  },
})(FormPenilaianJasaBoga);

//helper

function rowMapper(questions) {
  const row = [];

  questions.forEach((question) => {
    const data = question.sub.map((child) => ({ ...child }));
    row.push([ question.name, data ]);
  });
  return row;
}
